const TOKEN_KEY = 'admin_token';
const USER_KEY = 'admin_user';

const legacyStore = typeof window !== 'undefined' ? window.localStorage : null;
const sessionStore = typeof window !== 'undefined' ? window.sessionStorage : null;

const parseJwtPayload = (token) => {
  try {
    const payload = token.split('.')[1];
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
    return JSON.parse(window.atob(padded));
  } catch {
    return null;
  }
};

export const clearAdminAuth = () => {
  sessionStore?.removeItem(TOKEN_KEY);
  sessionStore?.removeItem(USER_KEY);
  legacyStore?.removeItem(TOKEN_KEY);
  legacyStore?.removeItem(USER_KEY);
};

export const setAdminAuth = ({ token, username, role }) => {
  clearAdminAuth();
  sessionStore?.setItem(TOKEN_KEY, token);
  sessionStore?.setItem(USER_KEY, JSON.stringify({ username, role }));
};

export const getAdminToken = () => {
  const token = sessionStore?.getItem(TOKEN_KEY);
  if (!token) return null;

  const claims = parseJwtPayload(token);
  if (!claims?.exp || claims.exp * 1000 <= Date.now()) {
    clearAdminAuth();
    return null;
  }

  return token;
};

export const getAdminUser = () => {
  try {
    return JSON.parse(sessionStore?.getItem(USER_KEY));
  } catch {
    return null;
  }
};

export const hasAdminAuth = () => Boolean(getAdminToken());
